import React from "react";
import ReactWOW from "react-wow";
import { $t } from '@/modules/i18n';
import { transformArray } from '@/utils/helper';

class Prizes extends React.Component {
  render() {
    const { message = {}, className } = this.props
    const explains = transformArray(message.explain)
    return (
      <div className={className}>
        <span className="deco-left">
          <span className="deco deco-1" />
          <span className="deco deco-2" />
          <span className="deco deco-3" />
        </span>
        <span className="deco-right">
          <span className="deco deco-4" />
          <span className="deco deco-5" />
          <span className="deco deco-6" />
        </span>
        <h2 className="section-title">{$t(message.title)}</h2>
        {
          message.desc && <p className="prizes-desc" dangerouslySetInnerHTML={{__html: $t(message.desc)}}></p>
        }
        {
          message.desc2 && <p className="prizes-sub-desc">{$t(message.desc2)}</p>
        }
        <div className="prizes-list">
        {
          message.list.map((item, index) => {
            const chances = transformArray(item.chances)
            return (
              <ReactWOW animation='fadeInUp' delay={`${index * 0.1}s`} key={item.title || index}>
                <div className="prizes-item" key={item.title}>
                  <h6 className="prizes-title">{$t(item.title)}</h6>
                  <p className="prizes-money">{$t(item.money)}</p>
                  {
                    chances.map(chance => <p className="chance" key={chance}>{chance}</p>)
                  }
                </div>
              </ReactWOW>
            )
          })
        }
        </div>
        {
          (message.full_width_list || []).map((item, index) => {
            return (
              <ReactWOW animation='fadeInUp' delay={`${(index + message.list.length) * 0.1}s`} key={item.title || index}>
                <div className={"prizes-item full-width"} key={item.title}>
                  <img className="prizes-image" src={item.image} alt=""/>
                  <div className="prizes-info">
                    <h6 className="prizes-title">{$t(item.title)}</h6>
                    <p className="prizes-money">{$t(item.money)}</p>
                  </div>
                </div>
              </ReactWOW>
            )
          })
        }
        <div className="prizes-explains">
        {
          explains.map(explain => <p className="explain" key={explain}>{explain}</p>)
        }
        </div>
      </div>
    );
  }
}

export default Prizes;
